<template>
  <div class="flex-column">
    <div>
      <div
        class="d-flex"
        style="height: 100px; position: relative">
        <el-image
          :src="profile.cover"
          fit="cover"
          class="w-100" />
        <div style="position: absolute; bottom: -26px; left: 0; right: 0; height: 56px">
          <div class="d-flex justify-content-center">
            <el-avatar
              class="rounded-circle"
              style="border: 2px solid white"
              :src="profile.avatar"
              alt=""
              :size="56" />
          </div>
        </div>
      </div>

      <div style="margin-top: 28px">
        <div class="d-flex justify-content-center font-14 fw-700">
          {{ conversation.swName ? conversation.swName : conversation.toName }}
        </div>
      </div>

      <div v-if="showInput">
        <div
          v-if="selectType == 'friend'"
          class="mt-4 px-12">
          <el-input
            v-model="content"
            type="textarea"
            resize="none"
            :rows="4"
            placeholder="Nhập lời mời kết bạn"
            :maxlength="150"
            show-word-limit />
        </div>
        <div
          v-if="selectType == 'message'"
          class="mt-4 px-12">
          <el-input
            class="text-break"
            v-model="content"
            type="textarea"
            resize="none"
            :rows="4"
            placeholder="Nhập nội dung tin nhắn" />
        </div>
      </div>
      <div
        v-else
        class="d-flex justify-content-center mt-2 px-12">
        <el-button
          v-if="requestFriend.is_requested === 1"
          class=""
          style="width: 130px"
          size="small"
          type="danger"
          @click="undoFriendRequest()"
          :disabled="profile.isBlocked !== null && profile.isBlocked === 1"
          plain>
          Thu hồi
        </el-button>
        <el-button
          v-else-if="profile.isFr === 0"
          class=""
          type="primary"
          size="small"
          plain
          :disabled="profile.isBlocked !== null && profile.isBlocked === 1"
          @click="showAddFriend()"
          style="width: 130px">
          <span class="fw-500 font-14">Kết bạn</span>
        </el-button>
        <el-button
          v-else-if="profile.isFr !== 0"
          class=""
          type="primary"
          size="small"
          plain
          @click="removeFriend()"
          style="width: 130px">
          <span class="fw-500 font-14">Hủy kết bạn</span>
        </el-button>
        <el-button
          class=""
          size="small"
          type="primary"
          style="width: 130px"
          @click="showMessageInput()">
          <span class="fw-500 font-14">Nhắn tin</span>
        </el-button>
      </div>

      <div
        v-if="showInput"
        class="d-flex justify-content-end mt-1 px-12">
        <el-button
          size="small"
          plain
          type="info"
          @click="showInput = false">
          Hủy
        </el-button>

        <el-button
          size="small"
          type="primary"
          @click="addFriend()"
          v-if="selectType == 'friend'">
          Kết bạn
        </el-button>
        <el-button
          size="small"
          type="primary"
          @click="sendMessage()"
          v-else>
          Gửi
        </el-button>
      </div>

      <div class="flex-column mt-2 py-2 border-top border-bottom px-12">
        <div class="d-flex">
          <div class="w-100px mx-1 text-secondary">Giới tính:</div>
          <div class="flex-1">{{ profile.gender === 0 ? "Nam" : "Nữ" }}</div>
        </div>
        <div class="d-flex mt-2">
          <div class="w-100px mx-1 text-secondary">Ngày sinh:</div>
          <div class="flex-1">{{ profile.sdob }}</div>
        </div>
        <div
          class="d-flex mt-2"
          v-if="isAdminUser() || app.showPhoneInContact">
          <div class="w-100px mx-1 text-secondary">Số điện thoại:</div>
          <div class="flex-1">{{ profile.phoneNumber }}</div>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-evenly">
        <div 
          v-if="isShowListFriend()"
          class="d-flex flex-column align-items-center text-center py-12">
          <div
            @click="onShareContactCard"
            class="z2-btn-status-off z2-btn-circle-large pointer">
            <IconV2 name="v2-profile" />
          </div>
          <span class="mt-2 font-13 fw-400">Gửi danh thiếp</span>
        </div>
        <div class="d-flex flex-column align-items-center text-center py-12">
          <div
            @click="handleActionBlock()"
            class="z2-btn-status-off z2-btn-circle-large pointer">
            <img
              src="/assets/icon/icon_red_block.svg"
              width="16px" />
          </div>
          <span class="mt-2 font-13 fw-400">
            {{ !profile.isBlocked ? "Chặn tin nhắn" : "Bỏ chặn tin nhắn" }}
          </span>
        </div>
      </div>

      <!-- <div class="mt-3">
        <div
          v-if="profile.isFr === 1"
          @click="removeFriend()"
          class="py-2 user_block pointer rounded-2">
          <i class="el-icon-delete mx-2" />
          Xoá khỏi danh sách bạn bè
        </div>
      </div> -->
    </div>

    <DialogBadWord
      v-if="replaceBadWord.show"
      :dataBadWord="replaceBadWord"
      :newMessage="content"
      :accountId="conversation.accountId"
      @sendReplace="sendReplace"
      @close="closeReplaceBadWord" />
    <el-dialog
      top="2vh"
      v-if="showMessageShare"
      title="Chia sẻ"
      width="520px"
      :visible.sync="showMessageShare"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      append-to-body>
      <div style="z-index: 999">
        <SharePopupV2
          :shareContactCard="shareContactCard"
          :message="messageShare"
          :accountId="conversation.accountId"
          @closeSharePopup="showMessageShare = false"
          :message-list="[]" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SharePopupV2 from "./message/SharePopupV2";
import DialogBadWord from "@/components/DialogBadWord";

export default {
  name: "ProfileInfoPopup",
  props: ["conversation", "data"],
  components: { DialogBadWord, SharePopupV2 },
  data() {
    return {
      showInput: false,
      selectType: "",
      content: "",
      requestFriend: {},
      profile: {},
      replaceBadWord: {
        show: false,
        items: [],
        content: "",
      },
      shareContactCard: {},
      showMessageShare: false,
      messageShare: {},
    };
  },
  watch: {
    data: {
      handler: function () {
        this.profile = JSON.parse(JSON.stringify(this.data));
        this.showInput = false;
      },
      deep: true,
    },
  },

  methods: {
    removeFriend() {
      let req = {
        accountId: this.conversation.accountId,
        friendId: this.conversation.toId,
      };
      this.$http.post("/api/contact/removeFriend", req).then((resp) => {
        if (resp.data.error_code === 0) {
          this.alert("success", "Xoá bạn thành công");
          this.$set(this.profile, "isFr", 0);
          this.closeDialog();
        }
      });
    },
    handleActionBlock() {
      if (this.profile.isBlocked === 1) this.actionUser("unblock");
      else this.actionUser("block");
    },

    actionUser(action) {
      let request = {
        accountId: this.conversation.accountId,
        friendId: this.conversation.toId,
        action: action,
        conversationId: this.conversation.id,
      };
      this.$http.post("/api/message/block", request).then((resp) => {
        if (resp?.data?.error_message !== "Successful.") return this.alert("error", "Có lỗi xảy ra vui lòng thử lại");
        if (action === "block") {
          this.profile.isBlocked = 1;
          this.alert("success", "Chặn thành công, người dùng này sẽ không thể gửi tin nhắn tới bạn");
        } else {
          this.profile.isBlocked = 0;
          this.alert("success", "Bỏ chặn thành công");
        }
        this.$bus.$emit("handleBlock", { action: action, toId: this.conversation.toId });
      });
    },

    undoFriendRequest() {
      this.$http
        .get("/api/contact/undoFriendRequest", {
          params: {
            accountId: this.conversation.accountId,
            userId: this.conversation.toId,
          },
        })
        .then((resp) => {
          if (resp.data.error_code === 0) {
            this.friendRequestStatus();
          }
          if (resp.data.error_code !== 0) {
            this.alertError(resp.data.error_message);
          }
        });
    },

    async addFriend() {
      this.visibleRequestFriend = false;
      this.$http
        .get("/api/contact/addFriend", {
          params: {
            msg: this.content,
            userId: this.conversation.toId,
            accountId: this.conversation.accountId,
          },
        })
        .then(async (resp) => {
          if (resp.data.error_code === 0) {
            let data = await this.friendRequestStatus();
            if (data.is_requested === 1) {
              this.alert("success", "Gửi kết bạn thành công");
              this.$set(this.requestFriend, "is_requested", 1);
            } else {
              this.alert("error", "Người dùng này đã từ chối trước đó");
            }
          } else if (resp.data.error_code === 222) {
            this.$set(this.profile, "isFr", 1);
          } else if (resp.data.error_code !== 0) {
            return this.alert("error", resp.data.error_message);
          }
        });
      this.showInput = false;
      this.closeDialog();
    },
    showAddFriend() {
      this.content = "Xin chào " + this.profile.displayName + ", kết bạn với mình nhé!";
      this.selectType = "friend";
      this.showInput = true;
    },
    showInfo() {
      this.showInput = false;
    },
    showMessageInput() {
      this.content = "";
      this.selectType = "message";
      this.showInput = true;
    },
    getProfileInfo() {
      this.profile = null;
      this.$http
        .get("/api/message/getProfileInfo", {
          params: {
            accountId: this.conversation.accountId,
            profileId: this.conversation.toId,
          },
        })
        .then((reps) => {
          this.profile = reps.data.data.changed_profiles[this.conversation.toId];
          if (this.profile.isFr === 0) {
            this.friendRequestStatus();
          }
        });
    },
    closeDialog() {
      this.$emit("closeProfile");
    },
    sendMessage() {
      if (!this.content) {
        this.alert("error", "Nhập nội dung cần gửi.");
        return;
      }
      let items = this.filterCharacter();
      if (items.length > 0) {
        this.replaceBadWord.show = true;
        this.replaceBadWord.items = items;
        this.replaceBadWordContent();
      } else {
        this.sendMesV2();
      }
    },
    filterCharacterArr() {
      const characterArr = this.app.characterFilters;
      const arrCommon = characterArr["0"];
      const arrOnwerAccount = characterArr[this.conversation.accountId];
      let array = [];
      if (arrCommon && arrCommon.length > 0) {
        array.push(...arrCommon);
      }
      if (arrOnwerAccount && arrOnwerAccount.length > 0) {
        array.push(...arrOnwerAccount);
      }
      const key = "content";
      const unique = [...new Map(array.map((item) => [item[key], item])).values()];
      return unique;
    },
    handleInputReplace() {
      this.replaceBadWord.items.forEach((it) => {
        for (let item of this.filterCharacterArr()) {
          if (it.replace.toLowerCase() == item.content.toLowerCase()) {
            it.replace = "****";
          }
        }
      });
      this.replaceBadWordContent();
    },
    replaceBadWordContent() {
      this.replaceBadWord.content = this.content;
      this.replaceBadWord.items.forEach((item) => {
        this.replaceBadWord.content = this.replaceBadWord.content.replaceAll(item.key, item.replace);
      });
    },
    filterCharacter() {
      let items = [];
      let check = true;
      let fil = this.app.accountSetting.filter((p) => p.accountId == this.conversation.accountId);
      if (fil != null && fil.length > 0) {
        check = fil[0].checkBadWord;
      }
      if (check) {
        let text = this.content;
        let arr = text.split(" ");
        if (this.filterCharacterArr() && this.filterCharacterArr().length > 0 && arr.length > 0) {
          for (let item of this.filterCharacterArr()) {
            arr.forEach((it) => {
              if (it.toLowerCase() == item.content.toLowerCase()) {
                let fil = items.filter((f) => f.key == it);
                if (fil == null || fil.length == 0) {
                  items.push({ key: it, replace: "****" });
                }
              }
            });
          }
        }
      }
      return items;
    },
    sendMesV2(keys, replace) {
      let request = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        groupId: this.conversation.toId,
        message: this.content,
        bannedKeyword: keys ? keys : [],
        replace: replace,
      };
      let url = "/api/message/sms";
      if (this.conversation.group) {
        url = "/api/message/groupMsg";
      }
      this.$http.post(url, request).then((resp) => {
        if (resp.data.error_code === 0) {
          this.alert("success", "Đã gửi tin nhắn");
        } else if (resp.data.error_code !== 0) {
          this.alert("error", resp.data.error_message);
        }
      });
      this.closeReplaceBadWord();
    },
    sendReplace({ newMessage, keys, replace }) {
      this.content = newMessage;
      this.sendMesV2(keys, replace);
    },
    closeReplaceBadWord() {
      this.content = "";
      this.showInput = false;
      this.replaceBadWord.show = false;
    },
    async friendRequestStatus() {
      let request = {
        accountId: this.conversation.accountId,
        friendId: this.conversation.toId,
      };
      return await this.$http.post("/api/conversation/friendRequestStatus", request).then((resp) => {
        if (resp.data.error_code === 0) {
          this.requestFriend = resp.data.data;
        }
        return resp.data.data;
      });
    },
    onShareContactCard() {
      this.shareContactCard = {
        accountId: this.conversation.accountId,
        friendId: this.profile.userId,
      };
      this.showMessageShare = true;
    },
  },

  created() {
    if (this.data) {
      this.profile = JSON.parse(JSON.stringify(this.data));
      if (this.profile.isFr === 0) {
        this.friendRequestStatus();
      }
      return;
    }
    if (this.conversation) {
      this.getProfileInfo();
    }
  },
};
</script>

<style lang="scss" scoped>
.user_block:hover {
  background-color: #eff2f7;
}
</style>
